import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../services/api';

export default function DeviceForm() {
  const { deviceId } = useParams();
  const navigate = useNavigate();

  const isEdit = !!deviceId;

  const [form, setForm] = useState({
    device_id: '',
    device_name: '',
    topic_name: '',
    status: 'active',
  });

  useEffect(() => {
  if (isEdit) {
    API.get('/devices')
      .then((res) => {
        console.log('Device list response:', res.data);

        const devicesArray = Array.isArray(res.data)
          ? res.data
          : res.data.devices || [];

        const found = devicesArray.find((d) => d.device_id === deviceId);

        if (found) {
          setForm(found);
        } else {
          alert('Device not found');
          navigate('/devices');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Failed to fetch devices');
      });
  }
}, [deviceId, isEdit, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await API.put(`/devices/${deviceId}`, form);
        alert('Device updated');
      } else {
        await API.post('/devices', form);
        alert('Device created');
      }
      navigate('/devices');
    } catch (err) {
      alert('Failed to save device');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>{isEdit ? 'Edit Device' : 'Create Device'}</h2>
      <form onSubmit={handleSubmit}>
        {!isEdit && (
          <>
            <label>Device ID:</label><br />
            <input name="device_id" value={form.device_id} onChange={handleChange} required /><br /><br />
          </>
        )}
        <label>Device Name:</label><br />
        <input name="device_name" value={form.device_name} onChange={handleChange} required /><br /><br />

        <label>Topic Name:</label><br />
        <input name="topic_name" value={form.topic_name} onChange={handleChange} required /><br /><br />

        <label>Status:</label><br />
        <select name="status" value={form.status} onChange={handleChange}>
          <option value="active">Active</option>
          <option value="closed">Closed</option>
        </select><br /><br />

        <button type="submit">{isEdit ? 'Update' : 'Create'}</button>
      </form>
    </div>
  );
}
